import HorizontalLine from "./HorizontalLine";

export default HorizontalLine;
